import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import Banner from '@cpg-its/ads.containers.banner';
import { TcsmStates } from '../../root/tcsm-model';
import { WysiwygWithReactLink } from '../../global/components/wysiwyg-with-react-link';
import { ContentSpacer } from '../../global/components/layout/generic-content-spacer';
import { MyCPGMidYearProps } from '../account-info/features/mycpg-midyear/models/mycpg-midyear-epi-props';
import { TcsmAppConfigs } from '../../global/models/configuration-models';
import { useMyCPGMidYearSettings } from '../account-info/features/mycpg-midyear/hooks/useMyCPGMidyearSettings';
import { MyCpgMidYearEnrollment } from '../arc/features/new-hire-enrollment/member/models/member-coverage-model';


interface Props {
	appConfig: TcsmAppConfigs;
}
export function MycpgMidyearPendingApprovalNotification(props: Props) {
	const { appConfig } = props;

	const settingsLoaded = useMyCPGMidYearSettings(appConfig.myCpgMidYearSettingsId);
	const midYearSettings = useSelector<TcsmStates, MyCPGMidYearProps>(state => state?.epiProps?.myCpgMidyearSettingsState?.epiContent);
	const pendingAdmin = useSelector<TcsmStates, MyCpgMidYearEnrollment[]>(state => state?.newHireEnrollmentState.myCpgPendingForApprovalEnrollment);
	const date = pendingAdmin?.[0]?.approve_by;
	if (!settingsLoaded) {
		return <LoadingCircle />;
	}

	return (
        <ContentSpacer>
            <Banner
                banner={{
                    type: 'warning',
					description: <WysiwygWithReactLink content={midYearSettings?.mycgpMidYearPendingForApprovalAlertDescription?.replace('[date]', date )} />,
                }}
            />
        </ContentSpacer>

		
		
	);

}